import { render, staticRenderFns } from "./editorsComponent.vue?vue&type=template&id=19086f20&"
import script from "./editorsComponent.vue?vue&type=script&lang=js&"
export * from "./editorsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports